module.exports = __webpack_public_path__ + "img/concept.9cb4a7c1.png";